var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 15,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.9877 6.40687C16.0676 5.98762 15.7479 5.48453 15.3482 5.48453L10.7917 4.81374L8.71328 0.453585C8.63334 0.285887 8.5534 0.202038 8.39353 0.118189C7.99383 -0.133359 7.5142 0.0343396 7.27439 0.453585L5.27593 4.81374L0.719445 5.48453C0.47963 5.48453 0.319753 5.56838 0.239815 5.73608C-0.0799383 6.07147 -0.0799383 6.57457 0.239815 6.90996L3.51729 10.2639L2.7179 15.0433C2.7179 15.211 2.7179 15.3787 2.79784 15.5464C3.03766 15.9657 3.51729 16.1334 3.91698 15.8818L7.99383 13.6179L12.0707 15.8818C12.1506 15.9657 12.3105 15.9657 12.4704 15.9657C12.5503 15.9657 12.5503 15.9657 12.6303 15.9657C13.0299 15.8818 13.3497 15.4626 13.2698 14.9595L12.4704 10.1801L15.7479 6.82611C15.9077 6.74226 15.9877 6.57457 15.9877 6.40687Z",
  fill: "#FFD000"
})));

export default __webpack_public_path__ + "static/media/yellowStar.f375ef5f.svg";
export { SvgComponent as ReactComponent };